import { profanity } from '@2toad/profanity';

const EXTRA_WORDS = new Set([
  'nigger', 'nigga', 'kike', 'chink', 'spic', 'dyke', 'tranny', 'spastic',
  'rape', 'rapist', 'retard', 'faggot', 'fag',
]);

function normalizeRough(s) {
  return s
    .toLowerCase()
    .replace(/[@0]/g, 'o')
    .replace(/[!1|]/g, 'i')
    .replace(/[$5]/g, 's')
    .replace(/[3]/g, 'e')
    .replace(/[4]/g, 'a')
    .replace(/[7]/g, 't');
}

export const containsBadWords = (text) => {
  if (!text) return false;
  if (profanity.exists(text)) return true;
  const rough = normalizeRough(text);
  if (profanity.exists(rough)) return true;
  const lower = text.toLowerCase();
  const tokens = lower.split(/[\s._\-@+0-9!#$%^&*()]+/).filter(Boolean);
  if (tokens.some((t) => EXTRA_WORDS.has(t))) return true;
  for (const w of EXTRA_WORDS) {
    if (w.length >= 4 && lower.includes(w)) return true;
  }
  return false;
};

export const validateNoBadWords = (...parts) => {
  const joined = parts.filter(Boolean).join('\n');
  return containsBadWords(joined)
    ? 'Please remove inappropriate language from your message.'
    : '';
};
